const canEditPlanTreatment = (plan, rights) => {
	if(rights.includes('edit_plan_treatment')) return true
	if(plan?.signed_at) return false
	if(['active', 'treatment_complete', 'in_process', 'finished'].includes(plan?.status)) return false
	return rights.includes('edit_plan_treatment_limited')
}

export { canEditPlanTreatment }
